import {
  createRouter as _createRouter,
  createMemoryHistory,
  createWebHistory,
} from "vue-router";
import GuestLayout from "@components/layouts/GuestLayout.vue";

let routes = [
  // ----------------------------------------------------------------- Pages
  //Home
  {
    path: "/",
    name: "Home",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Home.vue"),
  },
  {
    path: "/?pirotecnia/",
    name: "HomePirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Home.vue"),
  },

  //Categories
  {
    path: "/categorias/:category_id_slug",
    name: "Category",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Category.vue"),
  },
  {
    path: "/categorias/:category_id_slug/?pirotecnia",
    name: "CategoryPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Category.vue"),
  },

  //Subcategories
  {
    path: "/categorias/:category_id_slug/:subcategory_id_slug",
    name: "Subcategory",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Subcategory.vue"),
  },
  {
    path: "/categorias/:category_id_slug/:subcategory_id_slug/?pirotecnia",
    name: "SubcategoryPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Subcategory.vue"),
  },
  //Products details
  {
    path: "/productos/:slug",
    name: "ProductDetails",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/ProductDetails.vue"),
  },
  {
    path: "/productos/:slug/?pirotecnia",
    name: "ProductDetailsPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/ProductDetails.vue"),
  },

  //login
  {
    path: "/login",
    name: "Login",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Login.vue"),
  },
  {
    path: "/login/?pirotecnia",
    name: "LoginPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Login.vue"),
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Register.vue"),
  },
  {
    path: "/register/?pirotecnia",
    name: "RegisterPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Register.vue"),
  },
  {
    path: "/change_password",
    name: "ChangePassword",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/ChangePassword.vue"),
  },
  {
    path: "/change_password/?pirotecnia",
    name: "ChangePasswordPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/ChangePassword.vue"),
  },
  {
    path: "/reset_password",
    name: "ResetPassword",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/ResetPassword.vue"),
  },
  {
    path: "/reset_password/?pirotecnia",
    name: "ResetPasswordPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/ResetPassword.vue"),
  },

  //Miscelaneas
  {
    path: "/quienes_somos",
    name: "AboutUs",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/AboutUs.vue"),
  },
  {
    path: "/quienes_somos/?pirotecnia",
    name: "AboutUsPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/AboutUs.vue"),
  },
  {
    path: "/preguntas_frecuentes",
    name: "FrequentQuestions",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/FrequentQuestions.vue"),
  },
  {
    path: "/preguntas_frecuentes/?pirotecnia",
    name: "FrequentQuestionsPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/FrequentQuestions.vue"),
  },
  {
    path: "/terminos_y_condiciones",
    name: "TermsAndConditions",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/TermsAndConditions.vue"),
  },
  {
    path: "/terminos_y_condiciones/?pirotecnia",
    name: "TermsAndConditionsPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/TermsAndConditions.vue"),
  },
  {
    path: "/envios",
    name: "Shipments",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Shipments.vue"),
  },
  {
    path: "/envios/?pirotecnia",
    name: "ShipmentsPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Shipments.vue"),
  },
  {
    path: "/sucursales",
    name: "Branches",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Branches.vue"),
  },
  {
    path: "/sucursales/?pirotecnia",
    name: "BranchesPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Branches.vue"),
  },

  //Mensajes carrito de compras
  {
    path: "/carrito/mp/pago-exitoso",
    name: "pago-exitoso",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/carrito/mp/pago-exitoso.vue"),
  },
  {
    path: "/carrito/mp/pago-exitoso/?pirotecnia",
    name: "pago-exitosoPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/carrito/mp/pago-exitoso.vue"),
  },
  {
    path: "/carrito/mp/pago-pendiente",
    name: "pago-pendiente",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/carrito/mp/pago-pendiente.vue"),
  },
  {
    path: "/carrito/mp/pago-pendiente/?pirotecnia",
    name: "pago-pendientePirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/carrito/mp/pago-pendiente.vue"),
  },
  {
    path: "/carrito/mp/pago-fallido",
    name: "pago-fallido",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/carrito/mp/pago-fallido.vue"),
  },
  {
    path: "/carrito/mp/pago-fallido/?pirotecnia",
    name: "pago-fallidoPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/carrito/mp/pago-fallido.vue"),
  },

  //Carrito de compras
  {
    path: "/shopping_cart",
    name: "ShoppingCart",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/ShoppingCart.vue"),
  },
  {
    path: "/shopping_cart?pirotecnia",
    name: "ShoppingCartPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/ShoppingCart.vue"),
  },

  //Mis compras
  {
    path: "/mis_compras",
    name: "MisCompras",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/MisCompras.vue"),
  },
  {
    path: "/mis_compras/?pirotecnia",
    name: "MisComprasPirotecnia",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/MisCompras.vue"),
  },

  // ----------------------------------------------------------------- Shows
  {
    path: "/shows",
    name: "Shows",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/Shows.vue"),
  },
  {
    path: "/shows/:slug",
    name: "ShowGallery",
    meta: {
      layout: GuestLayout,
      requiresAuth: false,
      security: false,
    },
    component: () => import("@views/ShowGallery.vue"),
  },

  // ----------------------------------------------------------------- Anyone else
  {
    // will match everything
    path: "/:pathMatch(.*)*",
    component: () => import("@views/404.vue"),
  },
];

export function createRouter() {
  return _createRouter({
    // use appropriate history implementation for server/client
    // import.meta.env.SSR is injected by Vite.
    history: import.meta.env.SSR
      ? createMemoryHistory("/")
      : createWebHistory("/"),
    routes,
  });
}
